<template>
  <div v-loading="showFlag">
    <t-card>
      <!-- 年間売上実績レポート画面 -->
      <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
      <!-- 品質保証部の権限を追加する -->
      <!-- <div class="annualSalesPerformReportForm"> -->
      <div v-if="!isDLUser" class="annualSalesPerformReportForm">
        <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->

        <t-form label-position="right" label-width="100px">
          <t-row
            type="flex"
            justify="left
          "
          >
            <t-col :span="14">
              <t-form-item
                :label="$t('resource.ANNUAL_SALES_PERFORM.PERIOD')"
                class="marginBottom"
              >
                <t-select class="select-year-width" v-model="period.startYear">
                  <t-option
                    v-for="item in yearList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </t-option>
                </t-select>

                <t-select class="select-year-width" v-model="period.startMonth">
                  <t-option
                    v-for="item in monthList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </t-option>
                </t-select>
                <span>&nbsp;&nbsp;～&nbsp;&nbsp;</span>
                <t-select class="select-year-width" v-model="period.endYear">
                  <t-option
                    v-for="item in yearList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </t-option>
                </t-select>

                <t-select class="select-year-width" v-model="period.endMonth">
                  <t-option
                    v-for="item in monthList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </t-option>
                </t-select>
              </t-form-item>
            </t-col>
            <t-col :span="10">
              <!-- 検索 -->
              <t-button
                round
                type="primary"
                class="button_common_search marginRight"
                @click="searchClick()"
              >
                <i class="el-icon-search"></i>{{ $t("resource.sys.search") }}
              </t-button>
            </t-col>
          </t-row>

          <!-- 年間売上実績 -->
          <t-row>
            <t-col :span="12" style="width: calc(40vw); margin-bottom: 0">
              <div
                id="AnnualSalesAmount"
                shadow="hover"
                style="height: 370px; width: 170%"
              ></div>
            </t-col>
          </t-row>

          <!-- 売上目標 -->
          <t-row>
            <t-col :span="5">
              <t-input
                v-model="salesTargetAmount"
                disabled
                style="margin-bottom: 7px"
                class="sumInput"
              >
                <template slot="prepend">
                  <span class="span_style">
                    {{
                      $t("resource.ANNUAL_SALES_PERFORM.SALES_TARGET_AMOUNT")
                    }}</span
                  ></template
                >
              </t-input>
            </t-col>
          </t-row>

          <t-row>
            <t-table
              :data="annualSalesList"
              tooltip-effect="dark"
              style="width: 100%"
              header-cell-class-name="bg-default"
              :max-height="maxheight"
              highlight-current-row
              border
            >
              <t-table-column
                v-if="periodMonthList.length"
                fixed
                width="150"
                prop="department"
                :label="$t('resource.ANNUAL_SALES_PERFORM.MONTH')"
              ></t-table-column>

              <t-table-column
                v-for="(column, index) in periodMonthList"
                :key="index"
                :label="column.title"
                width="120"
                class-name="cell_txt_right"
                ><template #default="scope">
                  <t-input
                    v-if="editCellData(scope.row) == 'input'"
                    class="cell_input_custom"
                    :controls="false"
                    :maxlength="9"
                    tabindex="0"
                    :disabled="
                      scope.row.kbn == '3' ||
                      scope.row.kbn == '5' ||
                      scope.row.roleKbn === '0'
                    "
                    v-model="scope.row.dicNumValue['sum' + (index + 1)]"
                    @blur="changeCellData(scope.$index, index)"
                    @focus="
                      changeCellDataToNumber(scope.row, 'sum' + (index + 1))
                    "
                    @input="
                      scope.row.dicNumValue['sum' + (index + 1)] =
                        scope.row.dicNumValue['sum' + (index + 1)].replace(
                          /[^\d]/g,
                          ''
                        )
                    "
                    :ref="`inputRef${scope.$index}${index}`"
                    @keyup.native.enter="
                      focusNextInput(
                        scope.$index,
                        index,
                        column.title,
                        scope.row.kbn
                      )
                    "
                  ></t-input>
                  <!-- :ref="
                      'inputRef' +
                      generateRef(
                        scope.$index + '_' + (index + 1),
                        'inputNumber'
                      )
                    " -->
                  <t-input-number
                    v-else-if="editCellData(scope.row) == 'inputNumber'"
                    class="cell_input_number"
                    :ref="`inputRef${scope.$index}${index}`"
                    :controls="false"
                    :precision="0"
                    :min="-999999"
                    :max="999999"
                    :disabled="
                      scope.row.kbn == '3' ||
                      scope.row.kbn == '5' ||
                      scope.row.roleKbn === '0'
                    "
                    :value="scope.row.dicNumValue['sum' + (index + 1)]"
                    @change="changeCellData(scope.$index, index)"
                    v-model="scope.row.dicNumValue['sum' + (index + 1)]"
                    @keyup.native.enter="
                      focusNextInput(
                        scope.$index,
                        index,
                        column.title,
                        scope.row.kbn
                      )
                    "
                  ></t-input-number>
                </template>
              </t-table-column>

              <t-table-column
                v-if="periodMonthList.length"
                v-model="annualSalesList.subTotal"
                width="120"
                prop="subTotal"
                :label="$t('resource.ANNUAL_SALES_PERFORM.SUBTOTAL')"
                class-name="cell_txt_right"
              ></t-table-column>
            </t-table>
          </t-row>

          <t-row type="flex" justify="end">
            <div style="height: 60px">
              <t-col :span="24" style="padding-right: 20px; padding-top: 10px">
                <!--UPD 2024/12/16 ZLL 課題(#32906)_個人受注実績の見積件数が入力可能に変更 start↓ -->
                <!-- <t-button
                  type="primary"
                  style="width: 100px; height: 40px"
                  @click="confirm"
                  :disabled="roleKbn === '0'"
                  >{{ $t("resource.sys.sure") }}</t-button
                > -->

                <t-button
                  round
                  type="warning"
                  class="dialogButton_confirm_120_40"
                  ref="confirmBtn"
                  @click="confirm"
                  :disabled="roleKbn === '0'"
                  >{{ $t("resource.sys.sure") }}</t-button
                >
                <!--UPD 2024/12/16 ZLL 課題(#32906)_個人受注実績の見積件数が入力可能に変更 end↑ -->
              </t-col>
            </div>
          </t-row>

          <!-- 月間売上実績 -->
          <t-row>
            <t-col :span="12" style="width: calc(40vw)">
              <t-form-item class="marginBottom" label-width="0">
                <t-select
                  class="select-year-width"
                  v-model="eChartYM.startYear"
                >
                  <t-option
                    v-for="item in yearList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </t-option>
                </t-select>

                <t-select
                  class="select-year-width"
                  v-model="eChartYM.startMonth"
                >
                  <t-option
                    v-for="item in monthList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </t-option>
                </t-select>
              </t-form-item>
              <div
                id="MonthlySalesAmount"
                shadow="hover"
                style="height: 370px; width: 170%"
              ></div>
            </t-col>
          </t-row>

          <t-row>
            <t-table
              :data="monthSalesList"
              tooltip-effect="dark"
              style="width: 100%"
              header-cell-class-name="bg-default"
              :max-height="maxheight"
              highlight-current-row
              border
            >
              <!-- 日 -->
              <t-table-column
                v-if="periodDayList.length"
                fixed
                width="150"
                prop="department"
                :label="$t('resource.ANNUAL_SALES_PERFORM.DAY')"
              ></t-table-column>

              <t-table-column
                v-for="(column, index) in periodDayList"
                :key="index"
                :label="column.title"
                width="100"
                class-name="cell_txt_right"
                ><template #default="scope">
                  <span>{{ scope.row.dicNumValue["sum" + (index + 1)] }}</span>
                </template>
              </t-table-column>
            </t-table>
          </t-row>
        </t-form>
      </div>
      <!-- ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
      <!-- 品質保証部の権限を追加する -->
      <div v-else style="height: calc(100vh - 81px); width: 100%">
        <div class="welcomeText" style="font-size: 20pt">{{ strWelcome }}</div>
      </div>
      <!-- ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->
    </t-card>
  </div>
</template>
<script>
import { t } from "@/locales";
import {
  getMonthSalesEChartData,
  searchAnnualSalesPerformData,
  updateAnnualSalesPerformData,
} from "@/services/annualSalesReport";
import {
  formatCurrencyToNumber,
  formatStringToCurrency,
} from "@/utils/comFunction";
import { Message } from "@tellus/component";
import * as echarts from "echarts";
export default {
  data() {
    return {
      roleKbn: "0",
      //一覧高
      maxheight: window.innerHeight - 230,
      //期間年度
      yearList: [],
      //期間月度
      monthList: [],
      //期間値
      period: {
        startYear: "",
        startMonth: "",
        endYear: "",
        endMonth: "",
      },
      //期間月度
      periodMonthList: [],
      // 売上目標
      salesTargetAmount: "",
      //年間売上実績データ
      annualSalesList: [],
      //年間売上実績データ(更新用)
      annualSalesOutList: [],
      //月度差
      monthsDiff: 0,
      showFlag: false,

      //期間月リスト（「年間売上実績」echarts用）
      months: [],
      // 売上月間実績
      monthSalesList: [],
      monthSalesActualList: [], //売上月間実績リスト
      monthTargetSalesList: [], // 売上月間目標リスト

      // 粗利月間実績
      monthRoughProfitList: [],
      monthTargetRoughProfitList: [], // 粗利月間目標

      //期間日
      periodDayList: [],
      dayCount: 0, //日数
      //日付リスト（「月間売上実績」echarts用）
      days: [],
      // 売上日付実績
      daySalesList: [],
      dayTargetSalesList: [], // 売上日付目標

      dayProfitList: [], // 粗利日付実績
      dayTargetProfitList: [], // 粗利日付目標
      dayEChartMonthSale: 0,
      dayEChartMonthTargetSale: 0,
      dayEChartMonthDays: 0,
      dayEChartMonthSum: 0,

      //期間値(echarts用）
      eChartYM: {
        startYear: "",
        startMonth: "",
      },

      // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
      // 品質保証部の権限を追加する
      // UPD 2026/03/06 Wjx 課題_260306顧客からの改善したい点への対応 start↓
      // 「年間売上実績」と「月間売上実績」を「ホーム」から「レポート」に移動
      // isDLUser: false,
      isDLUser: true,
      // UPD 2026/03/06 Wjx 課題_260306顧客からの改善したい点への対応 end↑
      strWelcome: "ようこそ",
      // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
    };
  },

  watch: {
    "eChartYM.startYear": function (newYear, oldYear) {
      this.handleYMChange();
    },
    "eChartYM.startMonth": function (newMonth, oldMonth) {
      this.handleYMChange();
    },
  },

  mounted() {
    // UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
    // 品質保証部の権限を追加する
    // this.init();
    // this.$nextTick(() => {
    //   this.maxheight = document.body.clientHeight - 230;
    //   //「月間売上実績」グラフの初期化
    //   this.chartDom1 = document.getElementById("MonthlySalesAmount");
    //   this.chatMonthlySalesAmount = echarts.init(this.chartDom1);
    //   //「年間売上実績」グラフの初期化
    //   this.chartDom2 = document.getElementById("AnnualSalesAmount");
    //   this.chatAnnualSalesAmount = echarts.init(this.chartDom2);
    // });

    //セッションストレージに品質保証部フラグを取得する
    // DEL 2026/03/06 Wjx 課題_260306顧客からの改善したい点への対応 start↓
    // 「年間売上実績」と「月間売上実績」を「ホーム」から「レポート」に移動
    //this.isDLUser = sessionStorage.getItem("isDLUser") === "true";
    // DEL 2026/03/06 Wjx 課題_260306顧客からの改善したい点への対応 end↑

    if (!this.isDLUser) {
      this.init();
      this.$nextTick(() => {
        this.maxheight = document.body.clientHeight - 230;
        //「月間売上実績」グラフの初期化
        this.chartDom1 = document.getElementById("MonthlySalesAmount");
        this.chatMonthlySalesAmount = echarts.init(this.chartDom1);
        //「年間売上実績」グラフの初期化
        this.chartDom2 = document.getElementById("AnnualSalesAmount");
        this.chatAnnualSalesAmount = echarts.init(this.chartDom2);
      });
    }
    // UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
  },

  methods: {
    // 初期化
    init() {
      this.showFlag = true;
      //システム日
      var systemDate = new Date();
      //システム年
      var systemYear = systemDate.getFullYear();
      //システム月
      var systemMonth = systemDate.getMonth();

      //年度リスト
      for (let year = 2024; year <= systemYear + 1; year++) {
        this.yearList.push({
          value: year,
          label: year + t("resource.ANNUAL_SALES_PERFORM.YEAR"),
        });
      }

      //月度リスト
      for (let month = 1; month <= 12; month++) {
        this.monthList.push({
          value: month,
          label: month + t("resource.ANNUAL_SALES_PERFORM.MONTH"),
        });
      }

      //期間の初期値
      //システム月
      if (systemMonth <= 3) {
        //開始年度
        this.period.startYear = systemYear - 1;
        //終了年度
        this.period.endYear = systemYear;
      } else {
        //開始年度
        this.period.startYear = systemYear;
        //終了年度
        this.period.endYear = systemYear + 1;
      }

      //開始月度
      this.period.startMonth = 4;
      //終了月度
      this.period.endMonth = 3;

      this.eChartYM.startYear = systemYear;
      this.eChartYM.startMonth = systemMonth + 1;

      this.getDaysInMonth(this.eChartYM.startYear, this.eChartYM.startMonth);
      //検索
      this.searchClick();
    },

    // 検索
    searchClick() {
      if (!this.showFlag) {
        this.showFlag = true;
      }

      //チェック
      //月度差
      this.monthsDiff =
        (this.period.endYear - this.period.startYear) * 12 -
        parseInt(this.period.startMonth) +
        parseInt(this.period.endMonth);

      // console.log("this.monthsDiff---" + this.monthsDiff);

      if (this.monthsDiff < 0) {
        this.showFlag = false;
        Message.showError(
          t("message.CUS_M_ORDER_AMOUNT.DATE_COMPARE_MSG"),
          null
        );
        return;
      }

      if (this.monthsDiff >= 12) {
        this.showFlag = false;
        Message.showError(
          t("message.CUS_M_ORDER_AMOUNT.MONTHS_DIFF_MSG"),
          null
        );
        return;
      }
      searchAnnualSalesPerformData({
        searchStartYearMonth:
          this.period.startYear + "/" + this.period.startMonth,
        searchEndYearMonth: this.period.endYear + "/" + this.period.endMonth,
      })
        .then((res) => {
          // console.log(
          //   "this.searchAnnualSalesPerformData---res = " + JSON.stringify(res)
          // );

          //期間月度
          this.periodMonthList.length = 0;
          // 期間月リスト（echarts用）
          this.months.length = 0;

          this.roleKbn = res.annualSalesPerformList[0].roleKbn;
          //開始年月
          let year = this.period.startYear;
          let month = this.period.startMonth;
          //月度値
          let monthValue;
          //年月
          let yearMonth;
          for (let i = 0; i <= this.monthsDiff; i++) {
            if (parseInt(month) + i <= 12) {
              //月度値
              monthValue = parseInt(month) + i;
              //年月
              if (monthValue < 10) {
                yearMonth = year + "_0" + monthValue;
              } else {
                yearMonth = year + "_" + monthValue;
              }
            } else {
              //月度値
              monthValue = parseInt(month) + i - 12;
              //年月
              if (monthValue < 10) {
                yearMonth = year + 1 + "_0" + monthValue;
              } else {
                yearMonth = year + 1 + "_" + monthValue;
              }
            }
            // 期間月リスト（echarts用）
            this.months[i] = monthValue.toString();
            this.periodMonthList.push({
              title: monthValue + t("resource.CUS_M_ORDER_AMOUNT.MONTH"),
              yearMonth: yearMonth,
            });
          }

          //年間売上実績のクリア
          this.annualSalesList.length = 0;

          // console.log("年間売上実績データのクリア");
          //年間売上実績データ
          this.annualSalesList = res.annualSalesPerformList;
          this.getEChartData(this.annualSalesList);
          this.dataProcess();
          this.updateTableData(this.annualSalesList);

          this.InitChartAnnualSalesAmount();
          this.handleYMChange();
        })
        .catch((err) => {
          this.showFlag = false;
          Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"), null);
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    updateTableData(dtTable) {
      if (dtTable.length < 5) {
        return;
      }

      for (let index = 0; index < dtTable.length; index++) {
        const element = dtTable[index];
        dtTable[index].department = element.kbnName;
        dtTable[index].subTotal = element.subTotal;
      }

      this.annualSalesList = dtTable;

      for (let index = 0; index < dtTable.length; index++) {
        this.ubtotalCalculation(index);
      }
    },

    //データの処理
    dataProcess() {
      this.annualSalesList.map((item) => {
        if (
          item.kbn === "2" ||
          item.kbn === "3" ||
          item.kbn === "4" ||
          item.kbn === "5"
        ) {
          for (let colNum = 0; colNum <= this.monthsDiff; colNum++) {
            //月度列
            let colName = "sum" + (colNum + 1);
            item.dicNumValue[colName] = formatStringToCurrency(
              item.dicNumValue[colName]
            );
          }
          item.subTotal = formatStringToCurrency(item.subTotal);
        }
      });
    },

    //データの変更
    changeCellData(rowNum, colNum) {
      // console.log("rowNum:" + rowNum + " colNum:" + colNum);

      this.$nextTick(() => {
        let colName = "sum" + (colNum + 1);
        if (rowNum === 1 || rowNum === 2 || rowNum === 3 || rowNum === 4) {
          //月度列
          this.annualSalesList[rowNum].dicNumValue[colName] =
            formatStringToCurrency(
              formatCurrencyToNumber(
                this.annualSalesList[rowNum].dicNumValue[colName]
              )
            );
        } else {
          this.annualSalesList[rowNum].dicNumValue[colName] = parseInt(
            // this.$refs["inputRef" + rowNum + "_" + (colNum + 1)][0].currentValue
            this.annualSalesList[rowNum].dicNumValue[colName]
          );
        }
        this.ubtotalCalculation(rowNum);
      });
    },

    //小計の計算
    ubtotalCalculation(index) {
      //一覧データ
      let dtTable = this.annualSalesList;
      let sum = 0;

      for (let colNum = 0; colNum <= this.monthsDiff; colNum++) {
        //月度列
        let colName = "sum" + (colNum + 1);
        if (index === 0) {
          sum += parseInt(dtTable[index].dicNumValue[colName]);
        } else {
          sum += formatCurrencyToNumber(dtTable[index].dicNumValue[colName]);
        }
      }
      if (index === 0) {
        dtTable[index].subTotal = sum;
      } else {
        dtTable[index].subTotal = formatStringToCurrency(
          formatCurrencyToNumber(sum)
        );
      }

      this.salesTargetAmount = dtTable[1].subTotal;
    },

    //セルの編集
    editCellData(row) {
      if (
        row.kbn === "2" ||
        row.kbn === "3" ||
        row.kbn === "4" ||
        row.kbn === "5"
      ) {
        return "input";
      } else {
        return "inputNumber";
      }
    },

    //Enter処理
    focusNextInput(rowIndex, index, columnProp, kbn) {
      let columnIndex = this.periodMonthList.findIndex(
        (item) => item.title === columnProp
      );

      if (columnIndex == -1) {
        columnIndex = 0;
      }

      let nextRowIndex = rowIndex;
      if (kbn === "2") {
        nextRowIndex += 2;
      } else if (kbn === "4") {
        nextRowIndex = 0;
      } else {
        nextRowIndex += 1;
      }

      this.$nextTick(() => {
        var refName = `inputRef${nextRowIndex}${index}`;
        var refElement = this.$refs[refName];

        var tmpIndex = refElement.length - 1;

        if (refElement) {
          setTimeout(() => {
            this.$refs[refName][tmpIndex].focus();
          }, 0);
        } else {
          console.error(`Ref ${refName} is undefined`);
        }
      });
    },

    changeCellDataToNumber(curRow, columnName) {
      curRow.dicNumValue[columnName] = formatCurrencyToNumber(
        curRow.dicNumValue[columnName]
      );
    },

    // 編集
    confirm() {
      // ADD 2024/12/16 ZLL 課題(#32906)_個人受注実績の見積件数が入力可能に変更 start↓
      // フォーカス削除
      this.$refs.confirmBtn.$el.blur();
      // ADD 2024/12/16 ZLL 課題(#32906)_個人受注実績の見積件数が入力可能に変更 end↑

      this.showFlag = true;
      this.annualSalesOutList.length = 0;

      for (let colNum = 0; colNum < this.periodMonthList.length; colNum++) {
        //月度列
        let colName = "sum" + (colNum + 1);
        let kbnList = {};
        for (let rowNum = 0; rowNum < this.annualSalesList.length; rowNum++) {
          //区分
          let imKbn = this.annualSalesList[rowNum].kbn;

          var numVal;
          if (imKbn === "2" || imKbn === "4") {
            const moneyValue =
              this.annualSalesList[rowNum].dicNumValue[colName];
            numVal = formatCurrencyToNumber(moneyValue);
          } else {
            numVal = this.annualSalesList[rowNum].dicNumValue[colName];
          }
          kbnList[rowNum] = numVal;
        }
        //データの作成
        this.annualSalesOutList.push({
          mstYearMonth: this.periodMonthList[colNum].yearMonth, //年月
          mstOperatingDays: kbnList[0], //稼働日数
          mstSalesTarget: kbnList[1], //売上月間目標
          mstRoughProfitTarget: kbnList[3], //粗利月間目標
          mstUpdateUser: localStorage.getItem("userId"), //更新者
        });
      }

      // console.log(
      //   "this.annualSalesOutList---" + JSON.stringify(this.annualSalesOutList)
      // );

      updateAnnualSalesPerformData({
        annualSalesPerformList: this.annualSalesOutList,
      })
        .then((res) => {
          // console.log("showSuccess");
          Message.showSuccess(t("message.COMMON.UPDATE_SUCCESS"));
        })
        .catch((err) => {
          // console.log("showError");
          Message.showError(t("message.COMMON.UPDATE_FAILURE"), null);
        })
        .finally(() => {
          this.showFlag = false;
          this.searchClick();
        });
    },
    checkRefExists(refName) {
      return this.$refs[refName] !== undefined;
    },
    generateRef(index, type) {
      const refName = `inputRef${index}`;
      if (!this.checkRefExists(refName)) {
        return refName;
      } else {
        console.warn(`Ref ${refName} already exists.`);
      }
    },

    // 「年間売上実績」グラフの初期化
    InitChartAnnualSalesAmount() {
      this.option = {
        title: {
          text: "年間売上実績",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },
        toolbox: {
          feature: {
            saveAsImage: { show: true },
          },
        },
        xAxis: [
          {
            type: "category",
            name: "月",
            data: this.months,
            boundaryGap: false,
            axisPointer: {
              type: "shadow",
            },
            // axisLabel: {
            //   formatter: "{value} 月",
            // },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "金額(単位：円)",
            min: 0,
            max: this.calculateYAxisMax(
              Math.max(
                Math.max(...this.monthTargetRoughProfitList),
                Math.max(...this.monthRoughProfitList),
                Math.max(...this.monthTargetSalesList),
                Math.max(...this.monthSalesActualList)
              )
            ),
            interval:
              this.calculateYAxisMax(
                Math.max(
                  Math.max(...this.monthTargetRoughProfitList),
                  Math.max(...this.monthRoughProfitList),
                  Math.max(...this.monthTargetSalesList),
                  Math.max(...this.monthSalesActualList)
                )
              ) / 10,
          },
        ],
        grid: {
          left: "15%",
          right: "10%",
        },
        series: [
          {
            name: "売上月間目標",
            type: "line",
            color: "#FF8C00", //オレンジ
            tooltip: {
              valueFormatter: function (value) {
                return formatStringToCurrency(value) + " 円";
              },
            },
            data: this.monthTargetSalesList,
          },
          {
            name: "売上月間実績",
            type: "bar",
            color: "#A9A9A9", //グレー
            tooltip: {
              valueFormatter: function (value) {
                return formatStringToCurrency(value) + " 円";
              },
            },
            data: this.monthSalesActualList,
          },

          {
            name: "粗利月間目標",
            type: "line",
            color: "#FFD700", // イエロー
            tooltip: {
              valueFormatter: function (value) {
                return formatStringToCurrency(value) + " 円";
              },
            },
            data: this.monthTargetRoughProfitList,
          },

          {
            name: "粗利月間実績",
            type: "bar",
            color: "#87CEEB",
            tooltip: {
              valueFormatter: function (value) {
                return formatStringToCurrency(value) + " 円";
              },
            },
            data: this.monthRoughProfitList,
          },
        ],
      };
      this.option && this.chatAnnualSalesAmount.setOption(this.option);
    },

    // 「月間売上実績」グラフの初期化
    InitChartMonthlySalesAmount() {
      const labelsAndValues = [
        { label: "売上月産", value: this.dayEChartMonthSale },
        { label: "稼働日数", value: this.dayEChartMonthDays },
        {
          label: "日産売上",
          value: this.dayEChartMonthTargetSale,
        },
        { label: "売上実績", value: this.dayEChartMonthSum },
      ];

      const textElements = labelsAndValues.map((item, index) => {
        return {
          type: "text",
          left: `85%`,
          top: `${(index + 1) * 25}px`,
          style: {
            text: `${item.label}: ${item.value}`,
            fontSize: 12,
            color: "#000",
            textAlign: "left",
          },
        };
      });

      this.option = {
        title: {
          text: "月間売上実績",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },
        toolbox: {
          feature: {
            saveAsImage: { show: true },
          },
        },
        xAxis: [
          {
            type: "category",
            name: "日",
            data: this.days,
            min: 0,
            max: this.days[this.days.length - 1],
            boundaryGap: false,
            axisPointer: {
              type: "shadow",
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "金額(単位：円)",
            min: 0,
            max: this.calculateYAxisMax(
              Math.max(
                Math.max(...this.dayProfitList),
                Math.max(...this.dayTargetSalesList),
                Math.max(...this.daySalesList),
                Math.max(...this.dayTargetProfitList)
              )
            ),

            interval:
              this.calculateYAxisMax(
                Math.max(
                  Math.max(...this.dayProfitList),
                  Math.max(...this.dayTargetSalesList),
                  Math.max(...this.daySalesList),
                  Math.max(...this.dayTargetProfitList)
                )
              ) / 10,
            splitLine: {
              show: false,
            },
          },
        ],
        grid: {
          left: "15%",
          right: "10%",
        },

        graphic: textElements,

        series: [
          {
            name: "売上日間目標",
            type: "line",
            tooltip: {
              valueFormatter: function (value) {
                return formatStringToCurrency(value) + " 円";
              },
            },
            data: this.dayTargetSalesList,
          },
          {
            name: "売上日間実績",
            type: "line",
            tooltip: {
              valueFormatter: function (value) {
                return formatStringToCurrency(value) + " 円";
              },
            },
            data: this.daySalesList,
          },
          {
            name: "粗利日付目標",
            type: "line",
            tooltip: {
              valueFormatter: function (value) {
                return formatStringToCurrency(value) + " 円";
              },
            },
            data: this.dayTargetProfitList,
          },
          {
            name: "粗利日間実績",
            type: "line",
            tooltip: {
              valueFormatter: function (value) {
                return formatStringToCurrency(value) + " 円";
              },
            },
            data: this.dayProfitList,
          },
        ],
      };
      this.option && this.chatMonthlySalesAmount.setOption(this.option);
    },

    //月の日数を取得
    getDaysInMonth(year, month) {
      this.days.length = 0;
      month = month - 1;
      var date = new Date(year, month + 1, 0);
      var dayCount = date.getDate();
      this.dayCount = dayCount;
      for (let index = 0; index < dayCount; index++) {
        this.days[index] = index + 1;
      }
    },

    // 「年間売上実績」echartsデータの取得
    getEChartData(resData) {
      let monthSalesData = resData.filter((item) => item.kbn === "3");
      let monthSalesTargetData = resData.filter((item) => item.kbn === "2");
      let monthRoughProfitTargetData = resData.filter(
        (item) => item.kbn === "4"
      );
      let monthRoughProfitData = resData.filter((item) => item.kbn === "5");
      for (let index = 0; index < this.periodMonthList.length; index++) {
        //月度列
        let colName = "sum" + (index + 1);
        // 売上月間実績
        this.monthSalesActualList[index] =
          monthSalesData[0].dicNumValue[colName];
        // 売上月間目標
        this.monthTargetSalesList[index] =
          monthSalesTargetData[0].dicNumValue[colName];
        // 粗利月間実績
        this.monthRoughProfitList[index] =
          monthRoughProfitData[0].dicNumValue[colName];
        //粗利月間目標
        this.monthTargetRoughProfitList[index] =
          monthRoughProfitTargetData[0].dicNumValue[colName];
      }
    },

    // 「月間売上実績」echarts：年月変更処理
    handleYMChange() {
      if (!this.showFlag) {
        this.showFlag = true;
      }

      this.getDaysInMonth(this.eChartYM.startYear, this.eChartYM.startMonth);
      this.getEChartMonthSales();
    },

    getEChartMonthSales() {
      getMonthSalesEChartData({
        searchYearMonth:
          this.eChartYM.startYear + "/" + this.eChartYM.startMonth,
      })
        .then((res) => {
          if (!!res.monthSalesEchartDatas) {
            // console.log(
            //   "this.updateEChartMonthSales---res = " + JSON.stringify(res)
            // );

            //期間月度
            this.periodDayList.length = 0;
            //日リスト（「月間売上実績」echarts用）
            this.days.length = 0;

            //日数値
            for (let i = 1; i <= this.dayCount; i++) {
              this.periodDayList.push({
                title: i + t("resource.ANNUAL_SALES_PERFORM.DAY"),
              });
            }

            //売上月間実績のクリア
            this.monthSalesList.length = 0;
            // console.log("月間売上実績データのクリア");

            //年間売上実績データ
            this.monthSalesList = res.monthSalesEchartDatas;

            // 売上月産
            this.dayEChartMonthSale = formatStringToCurrency(
              this.monthSalesList[0].dayEChartMonthSale
            );

            // 稼働日数
            this.dayEChartMonthDays = this.monthSalesList[0].dayEChartMonthDays;

            this.dayEChartMonthTargetSale = formatStringToCurrency(
              this.dayEChartMonthDays === 0
                ? 0
                : formatCurrencyToNumber(this.dayEChartMonthSale) /
                    this.dayEChartMonthDays
            );

            this.monthDataProcess();

            for (let index = 0; index < this.monthSalesList.length; index++) {
              const element = this.monthSalesList[index];
              this.monthSalesList[index].department = element.kbnName;
            }
            this.getDaysInMonth(
              this.eChartYM.startYear,
              this.eChartYM.startMonth
            );
            this.InitChartMonthlySalesAmount();
          }
        })
        .catch((err) => {
          this.showFlag = false;
          Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"), null);
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    // 月間売上実績データの処理
    monthDataProcess() {
      this.daySalesList.length = 0;
      this.dayTargetSalesList.length = 0;
      this.dayProfitList.length = 0;
      this.dayTargetProfitList.length = 0;

      this.monthSalesList.map((item) => {
        for (let colNum = 0; colNum < this.dayCount; colNum++) {
          //月度列
          let colName = "sum" + (colNum + 1);
          item.dicNumValue[colName] = formatStringToCurrency(
            item.dicNumValue[colName]
          );
        }
      });

      for (let colNum = 0; colNum < this.dayCount; colNum++) {
        let sum1 = 0;
        let sum2 = 0;
        let sum3 = 0;
        let sum4 = 0;
        for (let i = 1; i <= colNum + 1; i++) {
          let colName = "sum" + i;
          sum1 += formatCurrencyToNumber(
            this.monthSalesList[1].dicNumValue[colName] || 0
          );
          sum2 += formatCurrencyToNumber(
            this.monthSalesList[0].dicNumValue[colName] || 0
          );
          sum3 += formatCurrencyToNumber(
            this.monthSalesList[3].dicNumValue[colName] || 0
          );
          sum4 += formatCurrencyToNumber(
            this.monthSalesList[2].dicNumValue[colName] || 0
          );
        }
        // 売上金額
        this.daySalesList[colNum] = sum1;
        // 売上日付目標
        this.dayTargetSalesList[colNum] = sum2;
        // 粗利日付実績
        this.dayProfitList[colNum] = sum3;
        // 粗利日付目標
        this.dayTargetProfitList[colNum] = sum4;

        if (colNum === this.dayCount - 1) {
          // 売上実績
          this.dayEChartMonthSum = formatStringToCurrency(sum1);
        }
      }
    },

    calculateYAxisMax(maxDataValue) {
      if (maxDataValue == 0 || isNaN(maxDataValue)) {
        maxDataValue = 1;
      }

      //測定レベルの決定（ここでは千、万、百万を例に）
      var magnitude = 1;

      while (maxDataValue >= magnitude * 10) {
        magnitude *= 10;
      }
      // 最も近い尺度倍数まで上に整列
      var maxAxisValue = Math.ceil(maxDataValue / magnitude) * magnitude;
      return maxAxisValue;
    },
  },
};
</script>
<style lang="scss" scoped>
.welcomeText {
  text-align: left;
  position: absolute;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
  overflow: hidden;
  background-size: 100% 100%;
  opacity: 1;

  font-weight: bold;
  color: black;
  justify-content: center;
  align-items: center;
}
</style>
